import { Button, Group, Text } from '@buildex/ui';
import { TenantLogo } from '@buildex/ui';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $session, logoutRequested } from '@buildex/core';

export function Header() {
  const { t } = useTranslation();
  const [session, onLogout] = useUnit([$session, logoutRequested]);

  return (
    <Group h="100%" pr="md" justify="space-between" flex={1} wrap="nowrap">
      <TenantLogo />
      <Group gap="sm">
        <Text size="sm" c="dimmed">
          {session?.name}
        </Text>
        <Button variant="subtle" size="xs" onClick={() => onLogout()}>
          {t('logout')}
        </Button>
      </Group>
    </Group>
  );
}
